var React = require("react");
var raf = require("raf");


var Canvas = React.createClass(
    {
        getDefaultProps: function ()
    {
        return {
            width: 1000,
            height: 800
        };
    },

    componentDidMount: function ()
    {
        if (this.props.main)
        {
            var screen = this.refs.screen;

            var ctx = screen.getContext("2d");

            var loop =  () =>
            {
                try
                {
                    this.props.main(ctx);
                }
                catch(e)
                {
                    console.error(e);
                }
                raf(loop);
            };

            raf(loop);
        }
    },

    shouldComponentUpdate: function ()
    {
        return false;
    },

    render: function ()
    {
        return (
            <canvas
                ref="screen"
                width={ this.props.width} height={ this.props.height }
                onMouseDown={ this.props.onMouseDown }
                onMouseMove={ this.props.onMouseMove }>
                onDblClick={ this.props.onDblClick }>
            </canvas>
        );
    }
});

module.exports = Canvas;
